export enum SearchType {
    UNIVERSITY = "universities",
    SCHOLARSHIP = "scholarships",
}
